module.exports = __webpack_public_path__ + "static/media/BradescoOperadora.5f17058c.svg";